import React from 'react'

function Button(props) {
  return (
    <div className="btn-div pointer">
      <button onClick={()=>props.onClickHandler()}  className={`${props.type} ${props.disabled ? 'disabled':''}`}>{props.value}</button>
    </div>
  );
}

export default Button
